import { CheckoutNavigationService } from '../../../services/CheckoutNavigationService/CheckoutNavigationService';
export var toCheckout = function (_a) {
    var context = _a.context, origin = _a.origin;
    return function (args) {
        var _a;
        var params = {
            cashierPaymentId: args.paymentId,
            checkoutId: args.checkoutId,
            locale: context.siteStore.locale,
            isPickupOnly: false,
            isPreselectedFlow: (_a = args.isPreselectedFlow) !== null && _a !== void 0 ? _a : false,
            continueShoppingUrl: args.continueShoppingUrl,
            disableContinueShopping: args.disableContinueShopping,
            successUrl: args.successUrl,
            contentAppId: args.contentAppId,
            contentComponentId: args.contentComponentId,
        };
        return new CheckoutNavigationService({ siteStore: context.siteStore, origin: origin }).navigateToCheckout(params);
    };
};
//# sourceMappingURL=toCheckout.js.map